module.exports = __webpack_public_path__ + "static/media/utah-logo.691b5ad4.png";